import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Observable} from "rxjs";
import {IdexService} from "../../../../idex.service";
import {Toast} from "../../../../shared/toast/toast";
import {TranslateService} from "@ngx-translate/core";
import {EformService} from "../../../service/eform.service";
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PreviewDocumentDialogComponent } from 'app/e-signature/tasks/preview-document-dialog/preview-document-dialog.component';
import { zDoxItem } from '../../../../shared/types';

declare var $: any;
declare let moment: any;

@Component({
   selector: 'app-upload',
   templateUrl: './upload.component.html',
   styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit, AfterViewInit {
   @ViewChild('fileUpload') fileUpload: any;
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() fieldName: any;
   @Input() labelName: any;
   @Input() isViewOnly: boolean;
   @Input() haveSign: boolean;
   @Input() isPreview: boolean;
   imageSignaturePreview: any;
   errorMessageMaxFile = false;
   errorMessageMaxSize = false;
   errorMessageAllowType = false;
   uploadError = false;
   files = [];
   filesTemp = [];
   accept = '';
   acceptErrMessage = '';
   allowType = '';
   private chunkSize = 500000;
   ext: any;
   object_file: any;
   public docDeleted: string[] = [];
   maxSizeOver: string;
   /**
    * Object สำหรับเก็บและจัดการ preview ของไฟล์ที่อัปโหลด \
    * An object used to store and manage the preview data of uploaded files.
    *
    * @type {Record<zDoxItem["id"], UnwrapObservable<ReturnType<IdexService["getDocumentEform"]>>>}
    */
   protected filesPreview: Record<zDoxItem["id"], UnwrapObservable<ReturnType<IdexService["getDocumentEform"]>>> = {};

   private filesToUpload: File[] = [];

   public index_old: any = -1;
   constructor(public service: IdexService,
               private toast: Toast,
               private translate: TranslateService,
               private eformService: EformService,
               private ref: ChangeDetectorRef,
               private dialog: MatDialog) {
   }

   ngOnInit(): void {
      this.loadImage('');
      this.setAcceptType();
      if (this.haveSign) {
         this.isViewOnly = false;
      }
      this.files = this.eformService.eForm.value.value && this.eformService.eForm.value.value[this.fieldName] ? this.eformService.eForm.value.value[this.fieldName] : this.files;
      if (this.files) {
         this.filesTemp = Object.assign([], this.files);
         this.form.controls[this.fieldName].setValue(this.files);
      }
      this.translate.get('max-size-upload-file').subscribe((s) => {
         this.maxSizeOver = s;
      });
      this.files.forEach((file) => {
         this.service.getDocumentEform(file.docId).subscribe((response) => {
            if (response?.id === file.docId) {
               this.filesPreview[file.docId] = response
            }
         }, (err) => {
            console.error(err);
         });
      });
   }

   setAcceptType() {
      if (this.field.allowType !== '') {
         const arrayType = this.field.allowType.split(',');
         for (let i = 0; i < arrayType.length; i++) {
            if (arrayType[i].indexOf('.') === -1) {
               this.accept += '.' + arrayType[i];
            } else {
               this.accept += arrayType[i];
            }
            this.allowType += arrayType[i];
            if (i < arrayType.length - 1) {
               this.accept = this.accept + ',';
               this.allowType = this.allowType + ', ';
            }
         }
      } else {
         this.accept = '.doc,.docx,.dot,.xls,.xlsx,.xlt,.pps,.ppt,.pptx,.pot,.tif,.tiff,.pdf,.txt,.jpg,.jpeg,.png,.bmp';
         this.acceptErrMessage = this.accept.replace(/,/g, ' ');
      }
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }

      if (hasFiles) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         $('#divUpload').addClass('drag-over');
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      $('#divUpload').removeClass('drag-over');
      const data = event.dataTransfer;
      let files;
      if (data.items) {
         files = [];
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               files.push(data.items[i].getAsFile());
            }
         }
      } else {
         files = data.files;
      }
      if (files.length > 0) {
         this.loadImage(files);
      }
   }

   onDragLeave() {
      $('#divUpload').removeClass('drag-over');
   }

   loadImage(myFile: any): void {
      this.filesToUpload = [];
      if (myFile.length > 0) {
         for (const element of myFile) {
            this.filesToUpload.push(element);
         }
      }
      let valid = false;
      let getfiles = [];
      this.uploadError = false;
      this.errorMessageMaxFile = false;
      this.errorMessageMaxSize = false;
      this.errorMessageAllowType = false;
      if (myFile.length === 0) {
         $('input[type="file"]').val('');
         return;
      }
      if (this.field.maximumFile && myFile.length > this.field.maximumFile) {
         this.errorMessageMaxFile = true;
         return;
      }
      for (const element of myFile) {
         if (element != null) {
            const ext = element.type;
            const name = element.name;
            if (this.validateExtension(ext, name) === false) {
               this.errorMessageAllowType = true;
               $('input[type="file"]').val('');
               $('input[type="file"]').attr('title', window.URL ? ' ' : '');
            } else if (this.field.maximumSize && element.size > ((1024 * 1024) * Number(this.field.maximumSize))) {
               $('input[type="file"]').val('');
               $('input[type="file"]').attr('title', window.URL ? ' ' : '');
               this.errorMessageMaxSize = true;

            } else if (this.field.maximumFile && (this.files.length + 1 > this.field.maximumFile)) {
               $('input[type="file"]').val('');
               $('input[type="file"]').attr('title', window.URL ? ' ' : '');
               this.errorMessageMaxFile = true;
            } else {
               this.errorMessageMaxFile = false;
               getfiles.push(element);
               valid = true;
            }
         }
      }
      if (valid) {
         if (this.field.required && getfiles.length > 0) {
            this.form.controls[this.fieldName].setErrors(null);
         }
         if (getfiles.length > 0) {
            this.uploadDoc(myFile)
         }
      }
      this.fileUpload.nativeElement.value = '';
   }

   validateExtension(v?, name?) {
      const extension = name.toString().split('.').pop();
      const allowedExtensions = this.field.allowType.toString().split(',');
      let valid = false;
      if (this.field.allowType !== '') {
         for (let ct = 0; ct < allowedExtensions.length; ct++) {
            const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
            const fileSelectedType = extension.toString().toLowerCase().lastIndexOf(allowedExtensions[ct]);
            if (fileSelected !== -1 || fileSelectedType !== -1) {
               valid = true;
            }
         }
         if (this.field.allowType.toLowerCase() === extension.toString().toLowerCase()) {
            valid = true;
         }
         return valid;
      } else {
         if (this.accept.includes(extension?.toLowerCase())) {
            return true;
         } else {
            return false;
         }
      }

   }

   focus() {
      return false;
   }

   deleteFile(index) {
      const docId = this.files[index].docId;

      if (this.field.required && this.files.length === 0) {
         this.form.controls[this.fieldName].setErrors({'incorrect': true});
      }

      if (this.filesTemp[index].isUpload) {

         this.service.deleteDocument(docId)
            .subscribe((response) => {
                  this.files.splice(index, 1);
                  this.filesTemp.splice(index, 1);
                  delete this.filesPreview[docId];
                  this.form.controls[this.fieldName].setValue(this.files);
               },
               (err) => {
                  this.toast.error(err)
               }, () => {
                  this.ref.detectChanges();
               });
      } else {
         this.files.splice(index, 1);
         this.filesTemp.splice(index, 1);
         this.docDeleted.push(docId)
         this.ref.detectChanges();
      }
   }


   submitDeleteFile() {
      // This is intentional.
   }

   private init(i: any): Observable<any> {
      return this.service.get('/init/upload/' + i);
   }

   //** upload file แนบรูปเอกสารบน Alfresco */
   uploadDoc(files: any) {
      const maxFileSize = 50 * 1024 * 1024; // 50 MB
      const fileLimitMB = 2 * 1024 * 1024 * 1024; // 2 GB in MB
      if (this.object_file === undefined || this.object_file === null) {
         this.object_file = [];
      }

      for (let loopFile = 0; loopFile < files.length; loopFile++) {
          const file: any = files[loopFile];

          if (this.field.maximumSize === null) { // ถ้าไม่ได้กำหนด maxFileSize มาให้ upload ได้ ไม่เกิน 50 MB ต่อไฟล์
            if (file.size > maxFileSize) { // ถ้าเกิน 50 MB จะไม่สามารถ upload ได้
               this.object_file = undefined;
               this.toast.error(this.maxSizeOver);
               return;
           }
          } else if (file.size > fileLimitMB) {
               this.errorMessageMaxFile = true;
               return;
            }

          files[loopFile].fullPath = files[loopFile].webkitRelativePath;
          this.object_file.push(files[loopFile]);

          this.init(loopFile).subscribe(result => {
              const key = result.key;
              const fileNo = result.fileNo;
              let offset = 0;
              const xhr = new XMLHttpRequest();

              const send = () => {
                  const end = Math.min(offset + this.chunkSize, file.size);
                  xhr.open('PUT', this.service.url + '/upload/' + key, true);
                  xhr.setRequestHeader('x-auth-token', this.service.user.token);
                  xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + file.size);
                  const blob = file.slice.call(file, offset, end);
                  xhr.send(blob);
              };

              xhr.onload = () => {
                  if (xhr.status === 308) {
                      if (file.canceled) {
                          this.service.post('/cancel/upload/' + key, null).subscribe(() => {
                                  // This is intentional.
                              },
                              (err) => {
                                  console.error(err);
                              });
                          return;
                      }
                      offset += this.chunkSize;
                      send();
                  } else if (xhr.status === 201) {
                      this.finish(key, '', file, '', fileNo, '');
                  }
              };

              send();
          }, error => {
              file.error = error;
          });
      }
   }

   finish(key: string, path: string, file: any, tin: string, loopFile: any, id?: string) {
      const rawName = file.fullPath || file.name;
      const encodedName = rawName.includes('/') ? rawName.split('/').map(encodeURIComponent).join('/') : encodeURIComponent(rawName);

      const body = {
         name: encodedName,
         destination: path,
         mimeType: file.type,
         tin: tin,
         id: id
      };

      const indexFilesToUpload = this.filesToUpload.findIndex((f) => f.name === rawName);
      const index = this.files.length + indexFilesToUpload;
      this.service.uploadDocumentTemp('eform', body, loopFile, key).subscribe((response) => {
         const docId = response.docId;
         const docName = response.docName;
         if (!this.files.length) {
            this.files.push({ docId, docName });
            this.filesPreview[docId] = this.filesToUpload[indexFilesToUpload];
         } else if (index !== -1 && this.files[index]) {
            let oldData = this.files[index];
            this.files[index] = { docId, docName };
            this.files.push(oldData);
            this.filesPreview[docId] = this.filesToUpload[indexFilesToUpload];
         } else if (index !== -1 && !this.files[index]) {
            this.files.push({ docId, docName });
            this.filesPreview[docId] = this.filesToUpload[indexFilesToUpload];
         }
         this.filesTemp.push({ docId, docName, isUpload: true  });
         this.form.controls[this.fieldName].setValue(this.files);

         this.object_file.splice(0, 1);
         if (this.object_file.length === 0) {
            const $input = $('input[type=file]');
            $input.val('');
            $input.attr('title', window.URL ? ' ' : '');
            this.object_file = null;
         }
      }, error => {
         if (error.status === 413) {
            file.error = error.message;
         } else if (error.status === 415) {
            file.error = error.message;
            const $input = $('input[type=file]');
            $input.val('');
            $input.attr('title', window.URL ? ' ' : '');
            this.object_file = null;
         }
      }, () => {
         this.ref.detectChanges();
      });
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   onClickListItem(docId, docName, index, mimetype, size) {
      if (!mimetype){
         mimetype = this.filesPreview[this.files[index].docId].mimeType;
      }

      $('#mat_list_' + index).css('background-color', '#edeeef');
      this.checkIndex(index);
      const dialogRef = this.dialog.open(PreviewDocumentDialogComponent, {
         disableClose: true,
         height: '630px',
         width: '1050px',
         data: { service: this.service, docId: docId, docName: docName, mimetype: mimetype, size: size, show: false, watermark: null }
      });
   }

   checkIndex(index) {
      if (this.index_old === -1) {
         this.index_old = index;
      } else if (index !== this.index_old) {
         $('#mat_list_' + this.index_old).css('background-color', '#FFFFFF');
         this.index_old = index;
      }
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }

   ngAfterViewInit(): void {
      if (this.eformService.isNotCompleteAllSign) {
         this.isViewOnly = this.eformService.isNotCompleteAllSign;
      }
       this.ref.detectChanges();
   }
}

/**
 * ดึง type ของข้อมูลภายใน Observable ออกมา หรือหาก T ไม่ใช่ Observable ก็คืนค่าเป็น T ตัวเอง
 *
 * Extracts the inner type of an Observable or returns the type as-is if T is not an Observable.
 */
type UnwrapObservable<T> = T extends Observable<infer U> ? U : T;
